import { FC } from "react";
import { IRegularTabButtonProps } from "./types";

const RegularTabButton: FC<IRegularTabButtonProps> = ({ selected, label }) => {
  return (
    <span
      className={`rounded-full ${selected ? "bg-blueDark dark:bg-blueHoverDark text-white" : "bg-greyBackground dark:bg-blueBorderDark hover:bg-blueHover dark:hover:bg-blueHoverDark"} px-3 py-1`}
    >
      {label}
    </span>
  );
};

export default RegularTabButton;
